import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Chip, IconButton, TableCell, TableRow, Tooltip } from '@mui/material';
import { RoleTableData } from '../types';

const RoleRow = ({
  data,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
}: {
  data: RoleTableData;
  onEdit: (role: RoleTableData) => void;
  onDelete: (role: RoleTableData) => void;
  canEdit: boolean;
  canDelete: boolean;
}) => (
  <TableRow key={data.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
    <TableCell component='th' scope='row'>
      {data.name}
    </TableCell>
    <TableCell>{data.code}</TableCell>
    <TableCell>
      {canDelete ? (
        <Chip size='small' label='Custom' color='primary' variant='outlined' />
      ) : (
        <Chip size='small' label='System' />
      )}
    </TableCell>
    <TableCell>
      <Tooltip title={canEdit ? 'Edit role' : 'System roles cannot be edited'}>
        <span>
          <IconButton size='small' disabled={!canEdit} onClick={() => onEdit(data)}>
            <EditOutlinedIcon fontSize='small' />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={canDelete ? 'Delete role' : 'System roles cannot be deleted'}>
        <span>
          <IconButton size='small' disabled={!canDelete} onClick={() => onDelete(data)}>
            <DeleteOutlineIcon fontSize='small' color={canDelete ? 'error' : 'disabled'} />
          </IconButton>
        </span>
      </Tooltip>
    </TableCell>
  </TableRow>
);

export default RoleRow;
